import React from 'react';
import './Page.css';

const Fees = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>Fee's</h1>
        
        <div className="fees-grid">
          <div className="fee-card">
            <h3>Buy & Sell Cryptocurrencies</h3>
            <p className="fee-amount">No fee incurred</p>
            <p className="fee-note">However, there can be up to a 2% spread.</p>
          </div>
          
          <div className="fee-card">
            <h3>Converting Cryptocurrencies</h3>
            <p className="fee-amount">No fee incurred</p>
            <p className="fee-note">However, there can be up to a 2% spread.</p>
          </div>
          
          <div className="fee-card">
            <h3>Send to External Wallet</h3>
            <p className="fee-amount">No fees incurred</p>
            <p className="fee-note">Other than blockchain fee</p>
          </div>
          
          <div className="fee-card">
            <h3>Send to Another Account</h3>
            <p className="fee-amount">No fees incurred</p>
            <p className="fee-note">No blockchain fee</p>
          </div>
          
          <div className="fee-card">
            <h3>Receive Cryptocurrencies</h3>
            <p className="fee-amount">No fees incurred</p>
            <p className="fee-note">Free to receive</p>
          </div>
        </div>
        
        <div className="fee-disclaimer">
          <p><strong>Note:</strong> All fees and spreads are subject to change. Please check our latest fee schedule before making transactions.</p>
        </div>
      </div>
    </div>
  );
};

export default Fees;
